import { withStateHandlers } from 'recompose'


export default withStateHandlers(
  ({ initialActiveTab }) => ({
    activeTab: initialActiveTab
  }),
  {
    setTab: () => ( activeTab, callback = () => false ) => {
      callback()
      return ({ activeTab })
    }
  }
)



// WEBPACK FOOTER //
// ./components/hoc/tabSelectHandler.js